import { CustomTabs as CustomTabsComponent } from '@/shared/ui/components';
import { t } from 'ttag';
import '../style.scss';
import { useDeviceManuals } from './useDeviceManuals';
import DeviceManualsPdf from './deviceManualsPdf';
import type { DeviceManualsProps } from './deviceManuals.types';

const CustomTabs = CustomTabsComponent as any;

/**
 * Renders the device manuals tab of the support page as three sub-tabs: instructions for use, patient manual and patient quick guide. Returns null while the tab is inactive, and every sub-tab renders the PDF view with the urls resolved from the support materials by the drawer hook, marking itself active by matching the current tab key.
 *
 * @param isActive - Whether the device manuals tab is currently selected.
 * @param materials - Support material records the manual urls are derived from.
 * @returns The device manuals sub-tab set, or null when inactive.
 */
const DeviceManuals = ({ isActive, materials }: DeviceManualsProps) => {
  const { state, navigateTab, generateUrl } = useDeviceManuals({ materials });

  if (!isActive) {
    return null;
  }

  return (
    <div id="support-materials">
      <CustomTabs
        activeKey={state.activeTab}
        onChange={navigateTab}
        items={[
          {
            key: '1',
            label: <div className="title-tab">{t`Instructions for use`}</div>,
            children: <DeviceManualsPdf isActive={state.activeTab === '1'} data={generateUrl()} />,
          },
          {
            key: '2',
            label: <div className="title-tab">{t`Patient manual`}</div>,
            children: <DeviceManualsPdf isActive={state.activeTab === '2'} data={generateUrl()} />,
          },
          {
            key: '3',
            label: <div className="title-tab">{t`Patient quick guide`}</div>,
            children: <DeviceManualsPdf isActive={state.activeTab === '3'} data={generateUrl()} />,
          },
        ]}
      />
    </div>
  );
};

export default DeviceManuals;
